export default function Parallax() {
// JavaScript for Parallax Effect
    (function() {
        const parallaxElements = document.querySelectorAll('.parallax');
        let latestKnownScrollY = 0;
        let ticking = false;

        function onScroll() {
            latestKnownScrollY = window.scrollY;
            requestTick();
        }

        function requestTick() {
            if (!ticking) {
                requestAnimationFrame(update);
            }
            ticking = true;
        }

        function update() {
            ticking = false;
            const currentScrollY = latestKnownScrollY;

            // Update parallax elements
            parallaxElements.forEach(function(element) {
                const speed = 0.5; // Adjust the speed for different effects
                const yPos = -(currentScrollY * speed);
                element.style.backgroundPosition = 'center ' + yPos + 'px';
            });
        }

        window.addEventListener('scroll', onScroll);
        window.addEventListener('load', onScroll);
    })();

}
